import {defineMessages} from 'react-intl';

export default defineMessages({
	successMessage: {
		id: 'couponCta.successMessage',
		defaultMessage: 'Coupon successfully applied!',
	},
	errorMessage: {
		id: 'couponCta.errorMessage',
		defaultMessage: 'No applicable promotion.',
	},
	alreadyApplied: {
		id: 'couponCta.alreadyApplied',
		defaultMessage: 'This coupon has already been added to the cart.'
	}
});
